import { createFormAction } from "redux-form-saga";
export const FORM_KEY = "PRODUCT_FORM_FORM";
export const ProductFormAction = createFormAction(FORM_KEY);
